import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { hoverable } from '~theme/snippets';

export const dropdown = css`
	--transition-time: 0.2s;
	--transition-delay: 0.15s;
	--save-zone-size: 1.2rem;
	top: 0;
	left: 0;
	padding: var(--save-zone-size);
	border: none;
	background: none;
	opacity: 0;
	outline: none;
	transform: translateY(-20px);
	transition: opacity var(--transition-time) ease-in-out,
		transform var(--transition-time) ease-in-out;

	&:popover-open {
		opacity: 1;
		transform: translateY(0);
		--transition-delay: 0s;
		@starting-style {
			opacity: 0;
			--transition-delay: 0.15s;
			transform: translateY(-20px);
		}
	}
`;

export const DropdownMenu = styled.div`
	display: flex;
	flex-direction: column;
	padding: 0.4rem;
	border: none;
	border-radius: var(--radius-xs);
	backdrop-filter: blur(6px);
	background-color: var(--color-grey-6-xl);
	transition: inherit;
`;

export const dropdownElement = css`
	display: flex;
	align-items: flex-start;
	padding: calc(16px / 2);
	border-radius: var(--radius-xxs);
	background-color: transparent;
	color: var(--color-white-solid);
	font-size: var(--font-size-m);
	gap: var(--gap-x3);
	line-height: var(--line-height-headline-s);
	transition: background-color var(--transition-time);
	${hoverable};
	& svg {
		width: auto;
		height: 2rem;
		& [fill] {
			fill: currentColor;
		}

		& [stroke] {
			stroke: currentColor;
		}
	}

	&:hover,
	&:focus {
		background-color: var(--color-white-xs);
	}

	&:active {
		background-color: var(--color-white-m);
	}

	&:disabled {
		background-color: var(--color-white-xs);
		color: var(--color-grey-52-solid);
	}
`;

export const DropdownElementHint = styled.div`
	color: var(--color-grey-52-solid);
	font-size: var(--font-size-base);
	line-height: var(--line-height-text-s);
`;

export const DropdownElementSecondaryIcon = styled.div`
	display: flex;
	margin-left: auto;

	& svg {
		& [fill] {
			fill: var(--color-grey-52-solid);
		}

		& [stroke] {
			stroke: var(--color-grey-52-solid);
		}
	}
`;

export const DropdownSeparator = styled.hr`
	height: 0.1rem;
	border: none;
	margin: 0.75rem 1.4rem;
	background-color: var(--color-grey-19-solid);
`;
